import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

const BORDERS = {
    error: 'border border-danger',
    actionRequired: 'border border-warning',
};

export default function SnackbarCard({ variant, className, children }) {
    return (
        <div
            className={cn(
                'relative rounded-lg bg-white shadow-md px-4 py-3 w-[356px]',
                variant && BORDERS[variant],
                className,
            )}
        >
            {children}
        </div>
    );
}

SnackbarCard.propTypes = {
    variant: PropTypes.oneOf(['error', 'actionRequired']),
    className: PropTypes.string,
    children: PropTypes.node,
};
